import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { llmKeysService } from '../services/llmKeys';

const key = ['llm-keys'] as const;

export function useLLMKeys() {
  return useQuery({ queryKey: key, queryFn: () => llmKeysService.list() });
}

export function useSetLLMKey() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ provider, apiKey }: { provider: string; apiKey: string }) =>
      llmKeysService.setKey(provider, apiKey),
    onSuccess: () => qc.invalidateQueries({ queryKey: key }),
  });
}

export function useDeleteLLMKey() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (provider: string) => llmKeysService.deleteKey(provider),
    onSuccess: () => qc.invalidateQueries({ queryKey: key }),
  });
}
